import { useState } from "react";
import { OverlayTrigger, Popover } from "react-bootstrap";
import { BiDotsHorizontalRounded } from "react-icons/bi";
import { GrChapterAdd } from "react-icons/gr";
import NewTicketModal from "@/Components/Utility/Modals/NewTicketModal/NewTicketModal";
import { Action, Ticket } from "@shared/Entities/EntityTypes";

interface ActionContextMenuProps {
	ticket: Ticket;
	action: Action;
}

/**
 * Hard-coded context menu for ticket actions.
 * In the future make this a context menu component with context item children with callbacks.
 */
export default function ActionContextMenu(props: ActionContextMenuProps) {
	const [isModalOpen, setIsModalOpen] = useState(false);
	const [isPopoverOpen, setIsPopoverOpen] = useState(false);

	const popover = (
		<Popover id="popover-basic">
			<ul style={{ overflow: "hidden", borderRadius: "0.3rem" }}>
				<li
					style={{ overflow: "hidden" }}
					className="flex items-center px-4 py-1 cursor-pointer hover:bg-gray-100"
					onClick={() => {
						setIsPopoverOpen(false);
						setIsModalOpen(true);
					}}
				>
					<GrChapterAdd className="mr-1" /> Copy to new ticket
				</li>
			</ul>
		</Popover>
	);

	const actionForNewTicket: Action = { ...props.action, id: 0 };

	return (
		<>
			<NewTicketModal
				isOpen={isModalOpen}
				onClose={() => setIsModalOpen(false)}
				preventSendAsEmail
				defaultNewTicket={{
					id: 0,
					actions: [actionForNewTicket],
					userId: props.ticket.userId,
					teamId: props.ticket.teamId,
					agentId: props.ticket.agentId
				}}
			/>

			<OverlayTrigger
				rootClose
				// rootCloseEvent="mousedown"
				trigger="click"
				placement="bottom-end"
				overlay={popover}
				show={isPopoverOpen}
				onToggle={() => setIsPopoverOpen((prevState) => !prevState)}
			>
				<button
					className="flex items-center justify-center border border-gray-300 bg-white rounded p-1 w-7 h-7"
					onClick={() => {}}
				>
					<BiDotsHorizontalRounded />
				</button>
			</OverlayTrigger>
		</>
	);
}
